// extracted by mini-css-extract-plugin
var _1 = "Zqd9XMTYhkWiIg8rhZVq";
var _2 = "Ppg1Vg5pSbN8l_5lqRoU";
export { _1 as "center", _2 as "spinner" }
